/*
 * @Description:导出页面为PDF格式
 * @Author: 王天琦
 * @Date: 2022-06-07 11:40:12
 */
import { ElMessageBox as MessageBox } from 'element-plus'
import axios from 'axios';
import store from '../store/index'
import html2pdf from 'html2pdf.js'
import ossClient from "../api/fileApi";
import * as echarts from 'echarts'
 

export default {
  install(app) {
    const getPdf = async function (domId, title, basicid, userid, btnEle, save = false) {
      if (1) {
        // 控制按钮显示/隐藏，检查btnEle是否存在
        if (btnEle && btnEle.$el) {
          btnEle.$el.style.display = 'none'
        }

        // 从原始文档导出桑基图为PNG（确保完全渲染后再导出）
        let sankeyPngUrl = null;
        const sankeyChartDom = document.getElementById('main3');
        if (sankeyChartDom) {
          // 先确保桑基图容器有合适的尺寸
          const containerWidth = sankeyChartDom.offsetWidth || 690;
          const containerHeight = sankeyChartDom.offsetHeight || 600;
          sankeyChartDom.style.width = containerWidth + 'px';
          sankeyChartDom.style.height = Math.max(containerHeight, 500) + 'px';
          sankeyChartDom.style.minHeight = '500px';
          sankeyChartDom.style.maxHeight = '800px';

          // 确保DOM重排和重新渲染
          sankeyChartDom.offsetWidth; // 触发重排

          // 等待DOM更新完成
          await new Promise(resolve => setTimeout(resolve, 100));

          const sankeyChart = echarts.getInstanceByDom(sankeyChartDom);
          if (sankeyChart) {
            // 强制桑基图重新渲染到完整尺寸
            const currentOption = sankeyChart.getOption();
            
            // 确保布局迭代完成
            if (currentOption.series && currentOption.series[0]) {
              currentOption.series[0].layoutIterations = 50; // 增加布局迭代次数
              currentOption.series[0].nodeGap = 15; // 增加节点间距确保清晰
            }

            sankeyChart.setOption(currentOption, {
              notMerge: false,
              lazyUpdate: false
            });

            // 调整图表尺寸以匹配容器
            sankeyChart.resize({
              width: containerWidth,
              height: Math.max(containerHeight, 500)
            });

            // 等待图表渲染和布局完成
            await new Promise(resolve => setTimeout(resolve, 500));

            // 导出桑基图为高分辨率PNG
            sankeyPngUrl = sankeyChart.getDataURL({
              type: 'png',
              pixelRatio: 3,  // 提高到3倍像素比，确保清晰
              backgroundColor: '#ffffff',
              excludeComponents: ['tooltip']
            });
          }
        }

        let ele = document.querySelector(domId)
        let opt = {
          margin: 0.5,
          filename: title + '.pdf',
          image: {
            type: 'jpeg',
            quality: 1
          },
          html2canvas: {
            scale: 2,
            dpi: 192,
            useCORS: true,
            logging: true,
            backgroundColor: '#ffffff',
            allowTaint: true,
            pagebreak: {
              mode: ['css', 'legacy']
            },
            onclone: async function(clonedDoc, element) {
              // 在克隆的文档中重新渲染图表，确保背景色和清晰度
              return new Promise((resolve) => {
                setTimeout(() => {
                  try {
                    // 如果有桑基图PNG，用PNG替换克隆文档中的canvas
                    if (sankeyPngUrl) {
                      const sankeyContainer = clonedDoc.querySelector('#main3');
                      if (sankeyContainer) {
                        const canvas = sankeyContainer.querySelector('canvas');
                        if (canvas) {
                          // 创建img标签
                          const img = clonedDoc.createElement('img');
                          img.src = sankeyPngUrl;
                          img.style.width = '100%';
                          img.style.height = 'auto';
                          img.style.maxWidth = '100%';
                          img.style.display = 'block';
                          img.style.margin = '0 auto';
                          img.style.objectFit = 'contain';
                          img.style.border = 'none';

                          // 移除所有canvas元素
                          const canvases = sankeyContainer.querySelectorAll('canvas');
                          canvases.forEach(c => c.remove());

                          // 调整img样式，缩放90%并居中
                          img.style.transform = 'scale(0.9)';
                          img.style.transformOrigin = 'center top';
                          
                          // 添加img到容器
                          sankeyContainer.appendChild(img);

                          // 调整容器样式，减少页边距
                          sankeyContainer.style.height = 'auto';
                          sankeyContainer.style.maxHeight = '800px';
                          sankeyContainer.style.overflow = 'visible';
                          sankeyContainer.style.width = '100%';
                          sankeyContainer.style.margin = '0 auto';
                          sankeyContainer.style.padding = '10px 0'; // 减少上下内边距
                          sankeyContainer.style.border = 'none';
                          sankeyContainer.style.textAlign = 'center'; // 确保图片居中
                        }
                      }
                    }

                    let canvases = clonedDoc.querySelectorAll('canvas');

                    canvases.forEach(function(canvas) {
                      // 设置canvas背景色为白色
                      canvas.style.backgroundColor = '#ffffff';

                      // 获取容器尺寸
                      const container = canvas.parentElement;
                      if (container) {
                        let chart = echarts.getInstanceByDom(canvas);

                        // 处理其他图表
                        if (chart) {
                          const containerWidth = container.offsetWidth || 690;
                          const containerHeight = container.offsetHeight || 600;

                          canvas.style.width = '100%';
                          canvas.style.height = '100%';
                          canvas.style.maxWidth = '100%';
                          canvas.style.maxHeight = '100%';

                          chart.resize({
                            width: containerWidth,
                            height: containerHeight
                          });

                          chart.dispatchAction({ type: 'restore' });
                          chart.dispatchAction({ type: 'highlight' });
                          chart.dispatchAction({ type: 'downplay' });
                          chart.setOption(chart.getOption(), {
                            notMerge: true,
                            lazyUpdate: false
                          });
                        }
                      }
                    });

                    // 图表块避页：每个 chart-block（单张图+其标题）高度都小于一页，
                    // 整块避页可成功，图与标题不会被分页拆开；
                    // 不再对 .custom-echarts 整容器避页——它包含全部图表总高超过一页，避页必然失败反被硬切
                    const chartBlocks = clonedDoc.querySelectorAll('.chart-block');
                    chartBlocks.forEach(function(block) {
                      block.style.pageBreakInside = 'avoid';
                      block.style.breakInside = 'avoid';
                    });

                    const echartsContainer = clonedDoc.querySelector('.custom-echarts');
                    if (echartsContainer) {
                      echartsContainer.style.width = '100%';
                      echartsContainer.style.maxWidth = '100%';
                      echartsContainer.style.height = 'auto';
                      echartsContainer.style.overflow = 'visible';
                    }

                    // 表格组避页：整组高度不超过一页（A4 内容区约 1025px，留余量取 900）时保持整体不跨页；
                    // 超过一页的大表改为允许在行之间分页，配合行级避页（avoid:['tr','td','th']）保证行不被切断
                    const tableGroups = clonedDoc.querySelectorAll('.table-group');
                    tableGroups.forEach(function(group) {
                      if (group.offsetHeight <= 900) {
                        group.style.pageBreakInside = 'avoid';
                        group.style.breakInside = 'avoid';
                      } else {
                        group.style.pageBreakInside = 'auto';
                        group.style.breakInside = 'auto';
                      }
                    });

                    // 超高一页的 avoid-break 标记元素同样放行（该 class 无样式定义，仅作分页标记），
                    // 避免整表避页失败后从行中间硬切
                    clonedDoc.querySelectorAll('.avoid-break').forEach(function(el) {
                      if (el.offsetHeight > 900) {
                        el.classList.remove('avoid-break');
                      }
                    });

                    // 确保评价指标容器不会被分页断开
                    const chapter4 = clonedDoc.querySelector('.chapter4');
                    if (chapter4) {
                      chapter4.style.pageBreakInside = 'avoid';
                      chapter4.style.breakInside = 'avoid';
                    }

                    // 确保每个KPI指标不会被分页断开
                    const kpiItems = clonedDoc.querySelectorAll('.kpi-item');
                    kpiItems.forEach(function(item) {
                      item.style.pageBreakInside = 'avoid';
                      item.style.breakInside = 'avoid';
                    });

                    // 确保表格单元格内容不会被截断
                    const tableCells = clonedDoc.querySelectorAll('td, th');
                    tableCells.forEach(function(cell) {
                      cell.style.wordWrap = 'break-word';
                      cell.style.wordBreak = 'break-all';
                      cell.style.overflowWrap = 'break-word';
                      // 表头保留 pre-line：使"核算结果\n[tCO₂]"这类含换行符的表头
                      // 在 PDF 中同样按两行显示（normal 会把换行符折叠成空格变成一行）
                      cell.style.whiteSpace = cell.tagName === 'TH' ? 'pre-line' : 'normal';
                      cell.style.pageBreakInside = 'avoid';
                    });
                  } catch (e) {
                    console.warn('图表重新渲染失败:', e);
                  }
                  // 所有渲染操作完成后才resolve
                  resolve();
                }, 800);
              });
            },
            timeout: 15000,
            async: true
          },
          jsPDF: {
            unit: 'in',
            format: 'a4',
            orientation: 'portrait',
            precision: 32,
            pagebreak: {
              // 不使用 avoid-all、也不对 .table-group/.custom-table 整体避页：
              // 高于一页的大表（SCOPE-1 结果表、SCOPE-3 清单表）整体避页必然失败，
              // 会被从行中间硬切导致“换页显示不全”；改为只保留行级避页（tr/td/th），
              // 大表在行之间分页，每一行保持完整
              mode: ['css', 'legacy'],
              avoid: ['tr', 'td', 'th', 'avoid-break', '.chart-block', '.kpi-item', '.kpi-container', '.chapter4'],
              before: '.page-break-before',
              after: '.page-break-after'
            }
          }
        }
        let strurl = title + '_' + basicid + '-校园'
        let obj = {
          "basic_id": basicid,
          "url": `/pdf/${strurl}`,
          "user_id": userid
        }

        axios.post(
          "/basic/info/pdf",
          obj
        ).then((res) => {
        })

        store.commit('fullscreenLoading', true)
        if (title !== '') {
          if (domId === '#pdf') {
            if(save){
              await html2pdf().set(opt).from(ele).save()
            }
            const res2 = await html2pdf().set(opt).from(ele).output('arraybuffer')
            //await client.client.putFileContents(`/pdf/${strurl}.pdf`, res2)
            await ossClient.uploadFile(res2, { directory: '/pdf', fileName: `${strurl}.pdf`, base_id: basicid })
          //  ossClient.uploadFile(res2,`/pdf/${strurl}.pdf`)
            // 恢复按钮显示，检查btnEle是否存在
            if (btnEle && btnEle.$el) {
              btnEle.$el.style.display = 'block'
            }
          }
          if (domId === '#pdf1') {
            var output = html2pdf().set(opt).from(ele).output('arraybuffer')
            // 再将二进制转为u8array
            output.then(async (res) => {
             // let result = await client.client.putFileContents(`/pdf/${strurl}.pdf`, res)
              let result2 = await ossClient.uploadFile(res, { directory: '/pdf', fileName: `${strurl}.pdf`, base_id: basicid })
            })

          }
        }
      }
      if (0) {
        MessageBox.confirm("该报告数据未经审核", "提示", {
        })
      }
    }
    app.config.globalProperties.getPdf = getPdf
    app.config.globalProperties.$getPdf = getPdf
  }
}